var modules_b2be58cc = {"image":"_p2lyth"};
import "../../../assets/BObdVZL0.css";

export { modules_b2be58cc as default };
//# sourceMappingURL=IconContent.module.less.js.map
